
/* eslint-disable */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { CalendarNav, Eventcalendar, MbscCalendarDayData, MbscCalendarEvent, MbscCalendarEventData, MbscEventClickEvent, MbscEventCreateEvent, MbscEventDragEvent, MbscResource, Popup, setOptions } from '@mobiscroll/react';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Styles from './stemsche.module.css';
import { Box, Button, IconButton, Typography } from '@mui/material';
import {ReactComponent as AddCircle} from './../../assets/SVG/add-circle.svg';
import {ReactComponent as Eye} from './../../assets/SVG/eye.svg';
import { showConfirmationModal } from '../ConfirmationModel';
import { ReactComponent as Camera } from './../../assets/SVG/camera copy.svg';
import { ReactComponent as CheckBox } from './../../assets/SVG/CheckboxGrantAccess.svg';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { createDrug, createEmptyFSDetailResults, deleteMed, DrugPostRequest, DrugSchema, FollicularStudyDetails, FollicularStudyResultsList, getDrugDetails, getFSResults, getStim, getTestResults, scheduleFA, Stim, StimulationEvent, StimulationMedication, TestResult } from '../../pages/Stim/helper.stim';
import { useAlert } from '../alertProvider';
import { convertDateToISOWithOffset, convertToLocalDateTime, formatDateToLocalYYYYMMDD, getNumberOfDays } from '../../services/time';
import DefaultLoader from '../defaultLoader';
import { EventcalendarBase } from '@mobiscroll/react/dist/src/core/components/eventcalendar/eventcalendar';
import EventModel from '../../pages/Stim/eventModal';
import AddDrugModal from '../../pages/Stim/addDrugModel';
import CreateDrugModal from '../../pages/Stim/createMedModal';
import CreateHormoneModal from '../../pages/Stim/createHormone';
import { PaginatedResponse, User } from '../../types';
import { usePatientContext } from '../SubPatinetProvider';
import HormoneValueModal from '../../pages/Stim/createHormoneTestModal';
import FolliculerModal from '../../pages/Stim/follicularModal';
import FollicularImageModal from './FollicularImageModal';
import { convertDateToDDMMYYYY, FollicularNumericSizeMap } from '../../utils/commonUtils';
import { getCurrentUser } from '../../services/userService';
import Tooltip from '@mui/material/Tooltip';
import EditIcon from '@mui/icons-material/Edit';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import Editicon from '../../assets/SVG/edit-2 (1).svg'

setOptions({
  theme: 'ios',
  themeVariant: 'light'
});

interface StimulationSchedularProps {
  id: number,
  height?: string
  isEdit?:boolean
}

export const StimulationSchedular: React.FC<StimulationSchedularProps> = ({id, height, isEdit}) => {

  const [stim, setStim] = useState<MbscResource[] | null>(null);
  const [stimEvents, setStimEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [trigger, setTrigger] = useState<MbscResource[] | null>(null);
  const [triggerEvents, setTriggerEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [hormone, setHormone] = useState<MbscResource[] | null>(null);
  const [hormoneEvents, setHormoneEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [editable, setEditable] = useState<boolean>(false);

  const [follicularStudyEvents, setFollicularStudyEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularImageEvents, setFollicularImageEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularDetailsEvents, setFollicularDetailsEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularETEvents, setFollicularETEvents] = useState<MbscCalendarEvent[] | null>(null);
  const [follicularSizeEvents, setFollicularSizeEvents] = useState<MbscCalendarEvent[] | null>(null);

  const [firstDate, setFirstDate] = useState<Date | null>();
  const [endDate, setEndDate] = useState<Date | null>();

  const [fullScreen, showFullScreen] = useState<boolean>(false);

  const [selectedStim, setSelctedStim] = useState<Stim | null>();
  
  const [focusEvent, setFocusEvent] = useState<MbscEventCreateEvent | null>();
  const [focusEventCal, setFocusEventCal] = useState<MbscCalendarEventData | null>();

  const [isNewEvent, setIsNewEvent] = useState<boolean>(true);
  const [showEventModal, setShowEventModal] = useState<boolean>(false);
  const [showDrugModal, setShowDrugModal] = useState<boolean>(false);
  const [showCreateDrugModal, setShowCreateDrugModal] = useState<boolean>(false);
  const [showCreateHormoneModal, setShowCreateHormoneModal] = useState<boolean>(false);
  const [showHormoneValueModal, setShowHormoneValueModal] = useState<boolean>(false);
  const [showFolliculareModal, setShowFollicularModal] = useState<boolean>(false);
  const [showFolliculareImageModal, setShowFollicularImageModal] = useState<boolean>(false);

  const [events, setEvents] = useState<MbscCalendarEvent[] | undefined>();
  const [referesh, doReferesh] = useState<boolean>(false);
  const [type, setType] = useState<'Trigger' | 'Stim' | null>(null);
  const [isOpuAvailable, setOpuAvailable] = useState<boolean>(false);
  const [selectionDate, setSelectionDate] = useState<undefined|string>(undefined);

  const {patientId} = usePatientContext();
  const { addAlert } = useAlert();

  const handleModelClose = () => {
    setShowCreateHormoneModal(false);
    setShowCreateDrugModal(false);
    setFocusEvent(null);
    setFocusEventCal(null);
  };

  const handleModelCloseAndReferesh = () => {
    setShowDrugModal(false);
    setShowEventModal(false);
    setFocusEvent(null);
    setFocusEventCal(null);
    setShowFollicularModal(false);
    setShowFollicularImageModal(false);
    setShowHormoneValueModal(false);
    setFocusEvent(null);
    setFocusEventCal(null);
    doReferesh(!referesh);
  };
  useEffect(() => {
    const setVh = () => {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    };

    // Update on load and resize
    window.addEventListener('resize', setVh);
    window.addEventListener('orientationchange', setVh);
    setVh();
  }, []);

  useEffect(() => {
    if (id) {
      getStim(id).then((stim: Stim) => setSelctedStim(stim)).catch(() => addAlert('Failed to fetch stim details.', 'error'));
    }
  }, [id, addAlert, referesh]);

  useEffect(() => {
    if (selectedStim?.cycle.cycle_start_date) {
      setFirstDate(convertToLocalDateTime(selectedStim?.cycle.cycle_start_date));
    }

    if (selectedStim?.cycle.cycle_end_date) {
      setEndDate(convertToLocalDateTime(selectedStim?.cycle.cycle_end_date));
    }
  }, [selectedStim]);

  useEffect(() => {
    if (patientId) {
      getTestResults(patientId,id ).then((results: TestResult[])=> {
        const hormoneResources: MbscResource[] = Array.from(
          new Map(
            results.map((result: TestResult) => [
              result.laboratory_test.id,
              {
                id: `hormone-${result.laboratory_test.id}`,
                name: result.laboratory_test.name,
                eventCreation: true,
                eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false
              },
            ])
          ).values()
        );
        console.log('hormone', 'setting resources', hormoneResources, firstDate, endDate);
        setHormone(hormoneResources);
        const hormoneEvents: MbscCalendarEvent[] = results
          .filter((result: TestResult) => 
            firstDate && convertToLocalDateTime(result.date) >= firstDate && (endDate ? convertToLocalDateTime(result.date) <= (endDate) : true)
          )
          .map((result: TestResult) => ({
            resource: `hormone-${result.laboratory_test.id}`,
            name: result.laboratory_test.name,
            title: result.results?.toString() || '+',
            date: convertToLocalDateTime(result.date),
            cssClass: 'hormone',
            id: result.id,
            unit: result.laboratory_test.unit,
          }));
        console.log('hormone', 'setting events', hormoneEvents);
        setHormoneEvents(hormoneEvents);
      });
    }
    if (selectedStim?.medications) {
      const stimDrugs: MbscResource[] = Array.from(
        new Map(
          selectedStim.medications
            .filter((med: StimulationMedication) => med.drug_type === 'STIMULATION') // Filter before mapping
            .map((med: StimulationMedication) => [`stim-${med.drug.id}`, med]) // Use drug.id as the unique key
        ).values()
      ).map((med: StimulationMedication) => ({
        id: `stim-${med.drug.id}`,
        name: med.drug.name,
        eventCreation: editable
      }));
      setStim(stimDrugs);
      const triggerDrugs: MbscResource[] = Array.from(
        new Map(
          selectedStim.medications
            .filter((med: StimulationMedication) => med.drug_type === 'TRIGGER') // Filter before mapping
            .map((med: StimulationMedication) => [`trigger-${med.drug.id}`, med]) // Use drug.id as the unique key
        ).values()
      ).map((med: StimulationMedication) => ({
        id: `trigger-${med.drug.id}`,
        name: med.drug.name,
        eventCreation: editable
      }));
      setTrigger(triggerDrugs);
      const eventsMedStim: MbscCalendarEvent[] = selectedStim?.medications?.filter((med: StimulationMedication) => med.drug_type === 'STIMULATION')
        .map((med: StimulationMedication) => ({
          id: med.id.toString(),
          title: med.quantity.toString(),
          start: convertToLocalDateTime(med.start_date),
          end: convertToLocalDateTime(med.end_date),
          resource: `stim-${med.drug.id}`,
        }));
      setStimEvents(eventsMedStim);
      const eventsMedtrigger: MbscCalendarEvent[] = 
      selectedStim?.medications?.filter((med: StimulationMedication) => med.drug_type === 'TRIGGER')
        .map((med: StimulationMedication) => ({
          id: med.id.toString(),
          title: med.quantity.toString(),
          start: convertToLocalDateTime(med.start_date),
          end: convertToLocalDateTime(med.end_date),
          resource: `trigger-${med.drug.id}`,
        }));
      setTriggerEvents(eventsMedtrigger);
    }
    if (selectedStim?.events) {
      const events: MbscCalendarEvent[] = selectedStim?.events?.map((med: StimulationEvent) => ({
        id: med.id,
        title: med.event_type.toUpperCase(),
        date: convertToLocalDateTime(med.date),
        resource: 'Event',
        allDay: true
      }));
      setEvents(events);
    }
    if(selectedStim?.events?.find((e: StimulationEvent) => e.event_type === 'OPU') !== undefined) {
      setOpuAvailable(true)
    }
    if (selectedStim) {
      getFSResults(selectedStim.id)
        .then((res: PaginatedResponse<FollicularStudyResultsList[]>) => res.objects)
        .then((results: FollicularStudyResultsList[]) => {
          const uniqueEventsMap = new Map<string, MbscCalendarEvent>();

          results.forEach((result: FollicularStudyResultsList) => {
            // Base events
            const baseEvents = [
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'fs' },
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'fi', title: result.left_ovary_path_url, id: result.id},
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'fd', title: result.details?.toString(), id: result.id},
              { date: formatDateToLocalYYYYMMDD(new Date(result.date)), resource: 'et', title: result.endometrium_thickness || '-' },
            ];

            baseEvents.forEach((event) => {
              const key = `${event.date}-${event.resource}`;
              if (!uniqueEventsMap.has(key)) {
                uniqueEventsMap.set(key, event);
              }
            });
            // Group follicular details
            if (result.details) {
              result.details.forEach((detail: FollicularStudyDetails) => {
                const processDetail = (size: string | null | undefined, count: string | null | undefined, side: 'L' | 'R') => {
                  const numericSize = size ? parseFloat(size) : null;
                  const follicleCount = count ? parseInt(count, 10) : 0;

                  if (numericSize !== null) {
                    const resource = numericSize < 2 ? '<2' : FollicularNumericSizeMap[numericSize.toString()];
                    const key = `${result.date}-${resource}`;

                    if (!uniqueEventsMap.has(key)) {
                      uniqueEventsMap.set(key, {
                        date: formatDateToLocalYYYYMMDD(new Date(result.date)),
                        resource,
                        title: 'L:0 R:0', // Initialize with compact format
                      });
                    }

                    // Update the respective L or R count
                    const event = uniqueEventsMap.get(key);
                    if (event && event.title) {
                      const match = event.title.match(new RegExp(`${side}:(\\d+)`));
                      const currentCount = match ? parseInt(match[1], 10) : 0;
                      const updatedTitle = event.title.replace(
                        `${side}:${currentCount}`,
                        `${side}:${currentCount + follicleCount}`
                      );
                      event.title = updatedTitle;
                    }
                  }
                };

                processDetail(detail.left_follicle_size, detail.left_no_of_follicles, 'L');
                processDetail(detail.right_follicle_size, detail.right_no_of_follicles, 'R');
              });
            }
          });

          // Convert Map to array and set the state
          const uniqueEvents = Array.from(uniqueEventsMap.values());
          setFollicularStudyEvents(uniqueEvents);
          console.log('Unique Events:', uniqueEvents); // Debugging log
        });
    }
    // eslint-disable-next-line
  }, [selectedStim, firstDate]);


  const myResources: MbscResource[] = [
    {
      name: 'Event',
      id: 'Event',
      eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false
    },
    {
      name: 'Medication',
      id: 'Medication',
      collapsed: false,
      isParent: true,
      eventCreation: false,
      children: [
        { name: 'Stim', id: 'med-stim', children: stim? stim: [], eventCreation: false, dragToMove: true},
        { name: 'Trigger', id: 'med-trigger', children: trigger? trigger: [], eventCreation: false, dragToMove: true},
        { name: 'Hormone', id: 'med-hormone', children: hormone? hormone: [], eventCreation: false, },
      ],
    },
    {
      name: 'Follicular Study',
      id: 'fs',
      collapsed: false,
      isParent: true,
      eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false,
      children: [
        { name: 'Follicular Image', id: 'fi',  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
        { name: 'Follicular Details', id: 'fd', eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
        { name: 'Endometrium Thickness (mm)', id: 'et',  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
        {
          name: 'Follicular Size (mm)',
          id: 'fsm',
          collapsed: false,
          eventCreation: false,
          children: [
            { name: 'Less than 2', id: '<2', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
            { name: '2', id: '2', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
            { name: '3', id: '3', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '4', id: '4', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '5', id: '5', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
            { name: '6', id: '6', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '7', id: '7', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '8', id: '8', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false },
            { name: '9', id: '9', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '10', id: '10', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '11', id:'11', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '12', id:'12', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '13', id:'13', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '14', id:'14', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '15', id:'15', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '16', id:'16', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '17', id:'17', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '18', id:'18', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '19', id:'19', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
            { name: '20', id:'20', eventCreation: false,  eventDragInTime: false, eventDragBetweenSlots: false, eventDragBetweenResources: false, eventResize: false},
          ],
        },
      ],
    },
  ];

  function handleFollicularDetailsClick(data: MbscCalendarEventData): void {
    setFocusEventCal(data);
    setShowFollicularModal(true);
  }

  function handleFollicularImageClick(data: MbscCalendarEventData): void {
    setFocusEventCal(data);
    setShowFollicularImageModal(true);
  }

  function handleHormonClick(data: MbscCalendarEventData) {
    if(!editable) return;
    setFocusEventCal(data);
    setShowHormoneValueModal(true);
  }

  function handleMedClick(data: MbscCalendarEventData): void {
    if(!editable) return;
    setFocusEventCal(data);
    setShowDrugModal(true);
  }
  

  function handleScheduleEventRender(data: MbscCalendarEventData) {
    if (data?.resource === 'Event') {
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      return (<span className={Styles.eventE} onClick={() => {handleEventClick(data);}}>{data.title}</span>);
    }
    if (data?.resource === 'fi') {
      if (data.title) {
        return (<div className={Styles.camera}><Eye onClick={() => handleFollicularImageClick(data)}/></div>);
      }
      return (<div className={Styles.camera}>{editable && <Camera onClick={() => handleFollicularImageClick(data)}/>}</div>);
    }
    if (data?.resource === 'fs') {
      return (<div className={Styles.camera}><CheckBox/></div>);
    }
    if (data?.resource === 'fd') {
      if (data.title) {
        return (<div  className={Styles.camera}><Eye onClick={() => handleFollicularDetailsClick(data)}/></div>);
      }
      // eslint-disable-next-line @typescript-eslint/no-use-before-define
      return (<div className={Styles.camera}>{editable && <AddCircle onClick={() => handleFollicularStudyModal(data)}/>}</div>);
    }
    if (data.resource?.toString().startsWith('hormone-')) {
      return (<span className={Styles.event_hm} onClick={() => handleHormonClick(data)}>{data.title}</span>);
    }
    if (data.resource?.toString().startsWith('trigger-') || data.resource?.toString().startsWith('stim-')) {
      return (<span onClick={() => handleMedClick(data)} className={Styles.event}>{data.title}</span>);
    }
    return (<span className={Styles.event}>{data.title}</span>);
  }


  const handleCreateDrugModelOpen = (name: string) => {
    if(!editable) return;
    switch(name) {
    case 'Hormone' : setShowCreateHormoneModal(true);
      return;  
    case 'Stim': setType('Stim');
      break;
    case 'Trigger': setType('Trigger');
      break;
    }

    setShowCreateDrugModal(true);
  };

   
  function handleResourceRender(resource: MbscResource, _day?: Date | undefined) {
    if (resource.id?.toString().includes('med-')) {
      return (<Tooltip title={resource.name} placement="top-start"><div className={Styles.medRes}><span className={Styles.resourceNameP}>{resource.name}</span>
      {editable &&
        <IconButton>
          {resource.name === 'Trigger' && isOpuAvailable ? 
          <AddCircle style={{opacity:0.5, cursor: 'not-allowed', }}/>:
          <AddCircle onClick={() => resource.name? handleCreateDrugModelOpen(resource.name): addAlert('Error', 'error')}/>           
          }        
        </IconButton>}
        </div></Tooltip>);
    }
    if (resource.id?.toString().includes('stim-') || resource.id?.toString().includes('trigger-') || resource.id?.toString().includes('hormone-')) {
      return (<Tooltip title={resource.name} placement="top-start"><div className={Styles.medResClose}><span className={Styles.resourceNameNP}>{resource.name}</span></div></Tooltip>);
    }
    if (resource.isParent) {
      return (<Tooltip title={resource.name} placement="top-start"><span className={Styles.resourceNameP}>{resource.name}</span></Tooltip>);
    }
    return (<Tooltip title={resource.name} placement="top-start"><span className={Styles.resourceNameNP}>{resource.name}</span></Tooltip>);
  }

  function getWeekday(arg0: number): React.ReactNode {
    switch (arg0) {
    case 0:
      return 'Sun';
    case 1:
      return 'Mon';
    case 2:
      return 'Tue';
    case 3:
      return 'Wed';
    case 4:
      return 'Thu';
    case 5:
      return 'Fri';
    case 6:
      return 'Sat';
    }
  }

  function daysFromFirstDate(date: Date) {
    if (firstDate) {
      return Math.ceil((date.getTime() - firstDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
    }
    return Math.ceil((date.getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)) + 1;
  }

  function daysFromLastDate(date: Date) {
    if (endDate) {
      return Math.ceil((date.getTime() - endDate.getTime()) / (1000 * 60 * 60 * 24)) + 1;
    }
    return null;
  }


  function handleRenderDay(args: MbscCalendarDayData) {
    const diff = daysFromFirstDate(args.date);
    const diffEnd = daysFromLastDate(args.date);
    return <div {...(diff > 0 && (diffEnd ? (diffEnd * -1) >= -1: true) ? {className: Styles.custHeaderc}: {className: Styles.custHeader})}>
      {diff > 0 ? <label className={Styles.headDay}>{diff.toString().padStart(2, '0')}</label>: <label className={Styles.headDay}>00</label>}
      <div className={Styles.dayHeader}><label>{args.date.getDate()}</label><span>{getWeekday(args.date.getDay())}</span></div>
    </div>;
  }


  const handleHeaderRender = useCallback(() => {
    return <div style={{display: 'flex', justifyContent: 'space-between', width: '100%'}}>
      <CalendarNav className="cal-header-nav"/>
      <div style={{display: 'flex', flexDirection: 'row'}}>

      { selectedStim && selectedStim.cycle.status === 'ACTIVE' && isEdit !== false &&(

        <div>
          {editable && <Button onClick={() => setEditable(false)} variant="contained" startIcon={<ExitToAppIcon />}>Exit Edit mode</Button>}
          {!editable && <Button onClick={() => setEditable(true)} variant="text" startIcon={<EditIcon />}>Edit</Button>}
        </div>
      )
      }
        <div>
          {!fullScreen && <Button onClick={() => showFullScreen(true)} variant="text" startIcon={<FullscreenIcon />}>
       Show full screen
          </Button>}
          {fullScreen && <Button onClick={() => showFullScreen(false)} variant="text" startIcon={<FullscreenExitIcon />}>
       Exit full screen
          </Button>}
        </div>
      </div>
    </div>;
  }, [fullScreen, editable, selectedStim]);

  function handleEventClick(data: MbscCalendarEventData) {
    setFocusEventCal(data);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    handleEventTypeCreation();
    setIsNewEvent(false);
  }

  function handleEventTypeCreation(): void {
    setShowEventModal(editable && true);
    setIsNewEvent(true);
  }

  function handleDrugCreation() {
    setShowDrugModal(true);
  }

  function handleHormoneTestCreation() {
    setShowHormoneValueModal(true);
  }

  function handleFollicularStudyModal(data: MbscCalendarEventData) {
    setFocusEventCal(data);
    setShowFollicularModal(true);
  }

  function handleFollicularStudyCreation(args: MbscEventCreateEvent) {
    if (selectedStim && selectedStim.id && focusEvent && focusEvent.event && focusEvent.event.start) {
      const startDate = focusEvent?.event.start as Date;
      const endDate = new Date(startDate);  // Clone the original date
      startDate.setHours(startDate.getHours() + 6);
      endDate.setHours(endDate.getHours() + 7);
      
      console.log('Date Original Date:', startDate);
      console.log('Date After Adding 1 Hour:', endDate);
      showConfirmationModal({
        message: 'Are you sure you want to schedule follicular scan?',
        onConfirm: () => {
          createEmptyFSDetailResults({
            stimulation_chart: selectedStim?.id,
            date: formatDateToLocalYYYYMMDD(focusEvent?.event.start as Date),
            time: '12:00:00'
          }).then(() => {
            return getCurrentUser().then((user: User) => {
              scheduleFA(
                user.id,
                formatDateToLocalYYYYMMDD(startDate),
                convertDateToISOWithOffset(startDate),
                convertDateToISOWithOffset(endDate),
                selectedStim.patient.id,
                user.clinic_department[0].department_id
              );
            });
          })
            .then(() => doReferesh(!referesh))
            .catch(() => addAlert('Failed to schedule follicular scan', 'error'));
        },
        onCancel: () => {
          console.log('Cancelled!');
        },
      });
      
    }
  }

  function handleEventCreate(args: MbscEventCreateEvent, inst: EventcalendarBase): void {

    if (!editable) return; 
    // if (args.event.start && (args.event.start as Date) <= new Date()) 
    // {
    //   addAlert('Choose a future date', 'error');
    //   return;
    // }
     // Commented for removing restriction for User action on previous dates. B.E will handle the validations.
          
    if (endDate && args.event.start && (args.event.start as Date) > endDate) {
      addAlert('Cycle ends on ' + convertDateToDDMMYYYY(endDate), 'error');
      return;
    }

    setFocusEvent(args);
    if (args.event.resource === 'Event') {
      handleEventTypeCreation();
    } else if (args.event.resource?.toString().startsWith('stim-') || args.event.resource?.toString().startsWith('trigger-')) {
      handleDrugCreation();
    } else if (args.event.resource?.toString().startsWith('hormone-')) {
      handleHormoneTestCreation();
    } else if (args.event.resource?.toString()==='fs') {
      handleFollicularStudyCreation(args);
    }
  }

  function handleDrugAddSubmit(id: string, name: string, type: 'Trigger' | 'Stim'): void {
    if (type === 'Stim' && stim) {
      if (!stim.some((entry) => entry.id === `stim-${id}`)) {
        setStim([...(stim || []), { id: `stim-${id}`, name }]);
      } else {
        addAlert('Stim already exists', 'warning');
      }
    }
  
    if (type === 'Trigger') {
      if (!trigger?.some((entry) => entry.id === `trigger-${id}`)) {
        setTrigger([...(trigger || []), { id: `trigger-${id}`, name }]);
      } else {
        addAlert('Trigger already exists', 'warning');
      }
    }
  }

  function handleHormoneSubmit(id: string, name: string) {
    if (hormone && !hormone.some((entry) => entry.id === `stim-${id}`)) {
      setHormone([...(hormone || []), { id: `hormone-${id}`, name }]);
    } else {
      addAlert('Hormone already exists', 'warning');
    }
  }

  const getValidRanges = () => {
    if (firstDate && endDate) {
      return [{ start: firstDate, end: endDate }]; // Enable between fromDate and toDate
    } else if (firstDate) {
      return [{ start: firstDate }]; // Enable from fromDate onward if no toDate
    }
    return []; // Default to no valid range if no dates are provided
  };

  const getInvalidRanges = () => {
    const invalidRanges = [];
    
    if (firstDate) {
      // Invalid range before `firstDate` (exclusive)
      invalidRanges.push({
        start: new Date(0), // Start from epoch time
        end: new Date(firstDate.getTime() - 24 * 60 * 60 * 1000), // Subtract one day
      });
    }
    
    if (endDate) {
      // Invalid range after `endDate` (exclusive)
      invalidRanges.push({
        start: convertDateToDDMMYYYY(endDate), // One millisecond after `endDate`
        end: new Date(8640000000000000), // Maximum valid JavaScript date
      });
    }
    
    return invalidRanges;
  };
  const calculateDays = (start_date: string, end_date: string): string => {
    if (start_date && end_date) {
      const start = convertToLocalDateTime(start_date);
      const end = convertToLocalDateTime(end_date);
      return Math.ceil((end.getTime() - start.getTime()) / (1000 * 60 * 60 * 24) + 1).toString();
    }
    return '';
  };

  const handleEventDragEnd = (args: MbscEventDragEvent, inst: EventcalendarBase) => {
    if (args.event.id && args.event.start && args.event.end && selectedStim) {
      getDrugDetails(args.event.id as number).then((med: DrugSchema) => {
        const req: DrugPostRequest = {
          drug: med.id,
          drug_type: med.drug_type,
          quantity: med.quantity,
          stim_chart: selectedStim?.id,
          start_date: formatDateToLocalYYYYMMDD(args.event.start as Date),
          number_of_days: parseInt(calculateDays(args.event.start as string, args.event.end as string)),
          start_time: med.start_time
        }; 
        createDrug(req, med.id).then(() => addAlert('Updated medication successfully', 'success')).catch(() => addAlert('UFailed to updated medication', 'error'));
      });
    }
  };

  // Tooltip Functionality Start
  const [isTooltipOpen, setIsTooltipOpen] = useState<boolean>(false);
  const [tooltipAnchor, setTooltipAnchor] = useState();
  const [tooltipData, setTooltipData] = useState<MbscCalendarEvent>({});

  const timer = useRef<ReturnType<typeof setTimeout>>();
  const openTooltip = useCallback((args: MbscEventClickEvent) => {
    const event: MbscCalendarEvent = args.event;
    // console.log('Event Data:', event);
    setTooltipData({
      ...event,
    });
    
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = undefined;
    }

    setTooltipAnchor(args.domEvent.target.closest('.mbsc-timeline-event'));
    setIsTooltipOpen(typeof event.resource === 'string' && (event.resource.toLowerCase().startsWith('hormone-') || event.resource.toLowerCase().startsWith('stim-') || event.resource.toLowerCase().startsWith('trigger-')));
  }, []);

  const handleEventHoverIn = useCallback(
    (args: MbscEventClickEvent) => {
      openTooltip(args);
    },
    [openTooltip],
  );

  const handleEventHoverOut = useCallback(() => {
    if (!timer.current) {
      timer.current = setTimeout(() => {
        setIsTooltipOpen(false);
      }, 500);
    }
  }, []);

  const handleMouseEnter = useCallback(() => {
    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = undefined;
    }
  }, []);

  const handleMouseLeave = useCallback(() => {
    timer.current = setTimeout(() => {
      setIsTooltipOpen(false);
    }, 500);
  }, []);

  const handleTooltipClose = useCallback(() => {
    setIsTooltipOpen(false);
  }, []);

  const handleToolTipEdit = (type:string) => { 
    setEditable(true);   
    if(type.startsWith('hormone-')) {
      handleHormonClick(tooltipData as unknown as MbscCalendarEventData);      
    }else if(type.startsWith('stim-') ) {      
      handleMedClick(tooltipData as unknown as MbscCalendarEventData);
    }else if(type.startsWith('trigger-')) {
      handleMedClick(tooltipData as unknown as MbscCalendarEventData);
    }
    handleTooltipClose();
  };
  const handleToolTipDelete = (type:string) => {    
    if(type.startsWith('stim-') ) {
      const deleteID = tooltipData.id ? parseInt(tooltipData.id.toString()) : 0;
      showConfirmationModal({
        message: 'Are you sure you want to delete this medication?',
        onConfirm: () => {
          deleteMed(deleteID).then(()=>addAlert('Deleted Stim Medication', 'success')).catch((error: any)=>{
            addAlert(`${error?.response?.data?.errors[0].detail}`, 'error');
          }).finally(()=>{
            handleModelClose();
            doReferesh(!referesh);
          });
        },
        onCancel: () => {
          setShowEventModal(false);
        },
      });
    }else if(type.startsWith('trigger-')) {
      const deleteID = tooltipData.id ? parseInt(tooltipData.id.toString()) : 0;
      showConfirmationModal({
        message: 'Are you sure you want to delete this medication?',
        onConfirm: () => {
          deleteMed(deleteID).then(()=>addAlert('Deleted Trigger Medication', 'success')).catch((error: any)=>{
            addAlert(`${error?.response?.data?.errors[0].detail}`, 'error');
          }).finally(()=>{
            handleModelClose();
            doReferesh(!referesh);          
          });
        },
        onCancel: () => {
          setShowEventModal(false);
        },
      });
    }
    handleTooltipClose();
  };

  // Tooltip Functionality End

  function formatDateToYYYYMMDD(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed
    const day = String(date.getDate()).padStart(2, '0');
  
    return `${year}-${month}-${day}`;
  }  

  if (selectedStim) {
    return (<div {...(fullScreen ? {className: Styles.fullscreen}: {className: Styles.exitFullscreen})}>
      {showFolliculareImageModal && focusEventCal && showFolliculareImageModal && <FollicularImageModal date={focusEventCal.startDate} cycleId={selectedStim.cycle.id} patient={patientId} id={focusEventCal.id} open={showFolliculareImageModal} onClose={handleModelCloseAndReferesh} stimId={selectedStim.id}/>}
      {selectedStim && selectedStim.id && editable && showHormoneValueModal && (focusEvent && focusEvent?.event.resource?.toString().split('-')[1] && focusEvent.event.start  || focusEventCal?.title && focusEventCal.id) && selectedStim && selectedStim.id &&  <HormoneValueModal value={focusEventCal?.title} id={focusEventCal?.id} cycle={selectedStim.cycle.id} selected_stim={selectedStim.id} patientId={patientId} {...(focusEvent?.event.start ? {date: new Date(focusEvent.event.start.toString())}: focusEventCal?.startDate && {date: new Date(focusEventCal?.startDate)})} {...(focusEvent?.event.resource?.toString().split('-')[1] ? {hormoneId: parseInt(focusEvent?.event.resource?.toString().split('-')[1])}: focusEventCal?.resource && {hormoneId: parseInt(focusEventCal?.resource?.toString().split('-')[1])})} hormonesModalOpen={showHormoneValueModal} handleHormonesModalClose={handleModelCloseAndReferesh}/>}
      {showCreateDrugModal && type && <CreateDrugModal handleDrugModalClose={handleModelClose} handleSubmitClose={handleDrugAddSubmit} drugModalOpen={showCreateDrugModal} type={type}/>}
      {showDrugModal && (focusEvent || focusEventCal) && (focusEvent?.event.resource || focusEventCal?.resource) && (focusEvent?.event.start || focusEventCal?.start) && <AddDrugModal medId={focusEventCal?.id} type={focusEvent?.event?.resource?.toString().split('-')[0] || focusEventCal?.resource?.toString().split('-')[0]} id={focusEvent?.event?.resource?.toString().split('-')[1] || focusEventCal?.resource?.toString().split('-')[1]} drugModalOpen={showDrugModal} handleDrugModalClose={handleModelCloseAndReferesh} stim={selectedStim.id} date={new Date(focusEvent?.event?.start?.toString() || focusEventCal?.start?.toString() || new Date())}/>}
      {editable && showEventModal && (focusEventCal || focusEvent) && <EventModel id={focusEventCal?.id} stim={selectedStim.id} patient={selectedStim.patient.id} partner={selectedStim.patient.partner?.id} scheduleEventModalOpen={showEventModal} handleScheduleModalClose={handleModelCloseAndReferesh} {...(focusEvent?.event.start && {eventDate: new Date(focusEvent?.event.start.toString())})} isNewEvent={!isNewEvent}/>}
      {showCreateHormoneModal && <CreateHormoneModal handleHormoneModalClose={handleModelClose} hormoneModalOpen={showCreateHormoneModal} handleSubmitClose={handleHormoneSubmit}/>}
      {showFolliculareModal && focusEventCal && focusEventCal.startDate && <FolliculerModal id={focusEventCal.id}  cycleDay={daysFromFirstDate(new Date(focusEventCal.startDate.toString()))} {...(selectedStim.cycle.lmp_date && {lmp: new Date(selectedStim.cycle.lmp_date)})} date={new Date(focusEventCal.startDate.toString())} stim={selectedStim.id} handleHormoneModalClose={handleModelCloseAndReferesh} hormoneModalOpen={showFolliculareModal}/>}
      <Eventcalendar
        key={editable ? 'editable' : 'readonly'}
        onEventDragEnd={handleEventDragEnd}
        invalid={getInvalidRanges()}
        onEventCreate={handleEventCreate}
        renderHeader={handleHeaderRender}
        {...(firstDate && {refDate: firstDate})}
        showControls={true}
        renderDay={handleRenderDay}
        dragToResize={editable}
        renderScheduleEvent={handleScheduleEventRender}
        renderResource={handleResourceRender}
        dragBetweenResources={false}
        dragToMove={editable}
        dragBetweenSlots={editable}
        resources={myResources}
        clickToCreate={editable}
        data={[...(events || []), ...(stimEvents || []), ...(triggerEvents || []), ...(hormoneEvents || []), ...(follicularDetailsEvents || []), ...(follicularETEvents || []), ...(follicularImageEvents || []), ...(follicularStudyEvents || []), ...(follicularSizeEvents || [])]}
        {...(fullScreen? {height: '100vh'}:height && {height: height})}
        {...(fullScreen && {width: '100%'})}
        view={{
          timeline: {
            virtualScroll: true,
            eventList: true,
            rowHeight: 'variable',
            type: 'month',
            resolutionHorizontal: 'day', // Full-day resolution
            timeCellStep: 1440, // Each cell represents 1 day
          },
        }}
        showEventTooltip={false}
        onEventHoverIn={handleEventHoverIn}
        onEventHoverOut={handleEventHoverOut}
        selectedDate={selectionDate ?? selectedStim.cycle.cycle_start_date}
        defaultSelectedDate={selectionDate ?? selectedStim.cycle.cycle_start_date}
        onSelectedDateChange={(e)=>setSelectionDate(formatDateToYYYYMMDD(new Date(String(e.date))))}
      />
      <Popup
        anchor={tooltipAnchor}
        contentPadding={false}
        display="anchored"
        isOpen={isTooltipOpen}
        scrollLock={false}
        showOverlay={false}
        touchUi={false}        
        onClose={handleTooltipClose}        
      >
        <Box bgcolor={'white'} p={2} borderRadius={2} boxShadow={2} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'}>          
            {tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? 
              <Typography variant='body2' color="textSecondary">
                Dose
                <Typography variant="body1" color="textSecondary" fontWeight="bold">{tooltipData?.title}</Typography>
              </Typography> :
              <Typography variant="h6" fontWeight="bold"  >
                Hormones                                                          
              </Typography>}
            {editable && <Box pl={2}>
              <IconButton                       
                size="small"
                onClick={()=>handleToolTipDelete(tooltipData.resource?.toString() ?? '')}
              >              
                <DeleteOutlineIcon sx={{fill:'textSecondary'}}/>
              </IconButton>                 
              <IconButton                
                size="small"
                onClick={()=>handleToolTipEdit(tooltipData.resource?.toString() ?? '')}
              >               
                {/* <BorderColorOutlinedIcon sx={{fill:'textSecondary'}}/> */}
                <img
                  src={Editicon}
                  alt="Edit"
                  style={{ width: 20, height: 20 }}
                />
              </IconButton> 
            </Box>}  
          </Box>
          <Box display={'flex'} justifyContent={'flex-start'} mt={1}>
            <Typography variant="body2" color="textSecondary">
              {tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? 'Drug Time' : 'Hormone Value'} 
              <Typography variant="body1" fontWeight="bold">{tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? getNumberOfDays(tooltipData.start ?? '', tooltipData.end ?? '').timeOfDay :tooltipData?.title}</Typography>
            </Typography>
            <Typography variant="body2" color="textSecondary" ml={4}>
              {tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? 'Days' : 'Units'} 
              <Typography variant="body1" fontWeight="bold">{tooltipData.resource?.toString().startsWith('stim') || tooltipData.resource?.toString().startsWith('trigger') ? getNumberOfDays(tooltipData.start ?? '', tooltipData.end ?? '').days : tooltipData?.unit??''}</Typography>
            </Typography>
          </Box>
        </Box>
      </Popup>
    </div>);
  } else {
    return <DefaultLoader/>;
  }
};